import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  buttons: {
    width: "100%",
  },
  deleteButton: {
    width: 150,
    "& svg": {
      height: 20,
      width: 20,
    },
    "& div": {
      fontWeight: "Bold",
    },
  },
}));

export default styles;
